// extracted by mini-css-extract-plugin
export default {"container":"ProfileTagsManagement_container__mJMl4","title":"ProfileTagsManagement_title__afgLZ"};